// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import React from 'react';
import type { Icon } from 'iconsax-react';

const ChartIcon: Icon = ({ size = 24, color, variant: _variant, className, style, ...rest }) => {
  const id = React.useId();
  const clipId = `${id}-clip`;
  const maskId = `${id}-mask`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <g clipPath={`url(#${clipId})`}>
        <mask id={maskId} style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <path d="M24 0H0V24H24V0Z" fill="white" />
        </mask>
        <g mask={`url(#${maskId})`}>
          <path d="M21 22.75H3C2.59 22.75 2.25 22.41 2.25 22C2.25 21.59 2.59 21.25 3 21.25H21C21.41 21.25 21.75 21.59 21.75 22C21.75 22.41 21.41 22.75 21 22.75Z" fill={color || 'currentColor'} />
          <path d="M5.59998 19.7509H4C3.04 19.7509 2.25 18.9609 2.25 18.0009V9.38086C2.25 8.42086 3.04 7.63086 4 7.63086H5.59998C6.55998 7.63086 7.34998 8.42086 7.34998 9.38086V18.0009C7.34998 18.9609 6.55998 19.7509 5.59998 19.7509ZM4 9.12085C3.86 9.12085 3.75 9.23085 3.75 9.37085V18.0009C3.75 18.1409 3.86 18.2509 4 18.2509H5.59998C5.73998 18.2509 5.84998 18.1409 5.84998 18.0009V9.38086C5.84998 9.24086 5.73998 9.13086 5.59998 9.13086H4V9.12085Z" fill={color || 'currentColor'} />
          <path d="M12.8002 19.7495H11.2002C10.2402 19.7495 9.4502 18.9595 9.4502 17.9995V6.18945C9.4502 5.22945 10.2402 4.43945 11.2002 4.43945H12.8002C13.7602 4.43945 14.5502 5.22945 14.5502 6.18945V17.9995C14.5502 18.9595 13.7602 19.7495 12.8002 19.7495ZM11.2002 5.93945C11.0602 5.93945 10.9502 6.04945 10.9502 6.18945V17.9995C10.9502 18.1395 11.0602 18.2495 11.2002 18.2495H12.8002C12.9402 18.2495 13.0502 18.1395 13.0502 17.9995V6.18945C13.0502 6.04945 12.9402 5.93945 12.8002 5.93945H11.2002Z" fill={color || 'currentColor'} />
          <path d="M19.9999 19.75H18.3999C17.4399 19.75 16.6499 18.96 16.6499 18V3C16.6499 2.04 17.4399 1.25 18.3999 1.25H19.9999C20.9599 1.25 21.7499 2.04 21.7499 3V18C21.7499 18.96 20.9599 19.75 19.9999 19.75ZM18.3999 2.75C18.2599 2.75 18.1499 2.86 18.1499 3V18C18.1499 18.14 18.2599 18.25 18.3999 18.25H19.9999C20.1399 18.25 20.2499 18.14 20.2499 18V3C20.2499 2.86 20.1399 2.75 19.9999 2.75H18.3999Z" fill={color || 'currentColor'} />
        </g>
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { ChartIcon };
